import { FC } from 'react';

export const DinersClubSvg: FC = () => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 251.15 158.68"
			enableBackground="new 0 0 251.15 158.68"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Diners Club</title>
			<g id="Card_Shape">
				<path
					fill="#FFFFFF"
					d="M8.504,156.68c-3.586,0-6.504-2.918-6.504-6.504V8.504C2,4.918,4.917,2,8.504,2h234.143
		c3.586,0,6.504,2.918,6.504,6.504v141.672c0,3.586-2.918,6.504-6.504,6.504H8.504z"
				/>
				<path
					fill="#004A97"
					d="M242.646,4c2.484,0,4.504,2.02,4.504,4.504v141.672c0,2.484-2.02,4.504-4.504,4.504H8.504
		C6.02,154.68,4,152.66,4,150.176V8.504C4,6.02,6.02,4,8.504,4H242.646 M242.646,0H8.504C3.827,0,0,3.827,0,8.504v141.672
		c0,4.677,3.827,8.504,8.504,8.504h234.142c4.677,0,8.504-3.827,8.504-8.504V8.504C251.15,3.827,247.323,0,242.646,0L242.646,0z"
				/>
			</g>
			<g>
				<path
					fill="#231F20"
					d="M42.043,114.033c0,3.001,2.145,3.35,4.053,3.35c8.418,0,11.18-6.349,11.18-12.154
		c0-7.286-4.674-12.544-12.192-12.544c-1.601,0-2.338,0.114-3.041,0.156V114.033z M38.224,95.761c0-3.504-1.83-3.273-3.581-3.31
		v-1.012c1.518,0.074,3.075,0.074,4.597,0.074c1.635,0,3.856-0.074,6.741-0.074c10.088,0,15.584,6.736,15.584,13.635
		c0,3.86-2.26,13.559-16.053,13.559c-1.985,0-3.818-0.077-5.648-0.077c-1.752,0-3.469,0.036-5.22,0.077v-1.013
		c2.335-0.236,3.468-0.313,3.581-2.961V95.761z"
				/>
				<path
					fill="#231F20"
					d="M67.097,94.828c-1.015,0-1.909-0.935-1.909-1.947c0-0.976,0.936-1.874,1.909-1.874
		c1.011,0,1.91,0.82,1.91,1.874C69.007,93.934,68.148,94.828,67.097,94.828 M62.93,117.619h0.738c1.09,0,1.871,0,1.871-1.289
		v-10.556c0-1.712-0.583-1.949-2.027-2.726v-0.622c1.831-0.55,4.015-1.285,4.169-1.403c0.274-0.156,0.505-0.197,0.703-0.197
		c0.191,0,0.271,0.234,0.271,0.549v14.956c0,1.289,0.859,1.289,1.951,1.289h0.659v1.013c-1.325,0-2.691-0.077-4.088-0.077
		c-1.403,0-2.806,0.036-4.247,0.077V117.619z"
				/>
				<path
					fill="#231F20"
					d="M74.967,106.008c0-1.44-0.43-1.828-2.258-2.57v-0.74c1.672-0.545,3.268-1.054,5.14-1.873
		c0.118,0,0.231,0.078,0.231,0.389v2.533c2.224-1.595,4.134-2.922,6.748-2.922c3.307,0,4.475,2.416,4.475,5.455v10.049
		c0,1.289,0.859,1.289,1.949,1.289h0.703v1.013c-1.368,0-2.73-0.077-4.131-0.077c-1.403,0-2.807,0.036-4.21,0.077v-1.013h0.703
		c1.092,0,1.867,0,1.867-1.289v-10.086c0-2.224-1.357-3.313-3.58-3.313c-1.248,0-3.235,1.011-4.524,1.871v11.527
		c0,1.289,0.861,1.289,1.952,1.289h0.7v1.013c-1.363,0-2.727-0.077-4.132-0.077c-1.4,0-2.804,0.036-4.205,0.077v-1.013h0.703
		c1.09,0,1.868,0,1.868-1.289V106.008z"
				/>
				<path
					fill="#231F20"
					d="M101.815,106.633c0.972,0,1.086-0.507,1.086-0.976c0-1.983-1.207-3.581-3.39-3.581
		c-2.374,0-4.011,1.75-4.478,4.558H101.815z M94.917,107.881c-0.08,0.35-0.08,0.933,0,2.259c0.229,3.7,2.611,6.738,5.724,6.738
		c2.146,0,3.823-1.169,5.261-2.608l0.543,0.545c-1.793,2.376-4.012,4.403-7.204,4.403c-6.196,0-7.443-6.003-7.443-8.495
		c0-7.637,5.142-9.898,7.866-9.898c3.159,0,6.55,1.987,6.587,6.117c0,0.237,0,0.468-0.037,0.703l-0.352,0.235H94.917z"
				/>
				<path
					fill="#231F20"
					d="M107.15,117.619h1.053c1.087,0,1.867,0,1.867-1.289v-10.945c0-1.205-1.44-1.443-2.025-1.755v-0.582
		c2.844-1.208,4.403-2.222,4.759-2.222c0.228,0,0.345,0.117,0.345,0.509v3.507h0.082c0.971-1.519,2.61-4.015,4.986-4.015
		c0.973,0,2.219,0.661,2.219,2.065c0,1.052-0.737,1.991-1.827,1.991c-1.212,0-1.212-0.94-2.577-0.94
		c-0.662,0-2.844,0.899-2.844,3.238v9.15c0,1.289,0.779,1.289,1.87,1.289h2.18v1.013c-2.143-0.041-3.774-0.077-5.45-0.077
		c-1.598,0-3.235,0.036-4.637,0.077V117.619z"
				/>
				<path
					fill="#231F20"
					d="M122.148,113.215c0.509,2.571,2.064,4.756,4.913,4.756c2.295,0,3.152-1.404,3.152-2.766
		c0-4.6-8.491-3.118-8.491-9.39c0-2.185,1.754-4.989,6.04-4.989c1.245,0,2.92,0.353,4.438,1.132l0.273,3.971h-0.896
		c-0.389-2.453-1.751-3.855-4.247-3.855c-1.558,0-3.037,0.895-3.037,2.57c0,4.561,9.036,3.156,9.036,9.273
		c0,2.57-2.063,5.301-6.701,5.301c-1.557,0-3.39-0.547-4.75-1.326l-0.431-4.481L122.148,113.215z"
				/>
				<path
					fill="#231F20"
					d="M168.509,98.488h-0.972c-0.741-4.555-3.975-6.387-8.336-6.387c-4.486,0-10.99,2.997-10.99,12.348
		c0,7.872,5.612,13.522,11.61,13.522c3.854,0,7.055-2.65,7.833-6.743l0.896,0.233l-0.896,5.69c-1.636,1.014-6.04,2.068-8.615,2.068
		c-9.113,0-14.878-5.884-14.878-14.65c0-7.988,7.13-13.718,14.766-13.718c3.154,0,6.192,1.016,9.192,2.069L168.509,98.488z"
				/>
				<path
					fill="#231F20"
					d="M169.915,117.619h0.737c1.095,0,1.872,0,1.872-1.289V94.635c0-2.534-0.583-2.612-2.066-3.041V90.97
		c1.558-0.505,3.196-1.205,4.015-1.676c0.423-0.23,0.738-0.429,0.853-0.429c0.238,0,0.315,0.237,0.315,0.549v26.917
		c0,1.289,0.858,1.289,1.948,1.289h0.659v1.013c-1.32,0-2.684-0.077-4.088-0.077c-1.402,0-2.803,0.036-4.247,0.077V117.619z"
				/>
				<path
					fill="#231F20"
					d="M194.93,116.488c0,0.704,0.426,0.741,1.087,0.741c0.47,0,1.052-0.037,1.562-0.037v0.821
		c-1.676,0.154-4.872,0.972-5.613,1.207l-0.194-0.119v-3.156c-2.335,1.908-4.13,3.275-6.9,3.275c-2.102,0-4.283-1.367-4.283-4.635
		v-9.977c0-1.015-0.154-1.989-2.333-2.181v-0.742c1.403-0.038,4.514-0.271,5.022-0.271c0.433,0,0.433,0.271,0.433,1.13v10.05
		c0,1.17,0,4.518,3.389,4.518c1.323,0,3.076-1.011,4.711-2.372v-10.484c0-0.778-1.869-1.207-3.269-1.595v-0.701
		c3.503-0.237,5.687-0.547,6.076-0.547c0.314,0,0.314,0.271,0.314,0.701V116.488z"
				/>
				<path
					fill="#231F20"
					d="M202.681,114.229c0,1.48,1.403,3.975,4.013,3.975c4.168,0,5.92-4.091,5.92-7.561
		c0-4.207-3.191-7.712-6.229-7.712c-1.447,0-2.653,0.936-3.704,1.833V114.229z M202.681,103.631
		c1.558-1.321,3.663-2.805,5.805-2.805c4.52,0,7.247,3.939,7.247,8.184c0,5.102-3.741,10.209-9.315,10.209
		c-2.88,0-4.4-0.938-5.415-1.367l-1.165,0.896l-0.817-0.427c0.348-2.298,0.545-4.558,0.545-6.936v-16.75
		c0-2.534-0.587-2.612-2.067-3.041V90.97c1.56-0.505,3.195-1.205,4.012-1.676c0.43-0.23,0.741-0.429,0.86-0.429
		c0.232,0,0.31,0.237,0.31,0.549V103.631z"
				/>
				<path
					fill="#231F20"
					d="M34.6,141.286h0.298c0.762,0,1.568-0.104,1.568-1.208v-11.106c0-1.105-0.806-1.21-1.568-1.21H34.6v-0.637
		c0.826,0,2.099,0.085,3.14,0.085c1.059,0,2.329-0.085,3.326-0.085v0.637h-0.299c-0.759,0-1.567,0.105-1.567,1.21v11.106
		c0,1.104,0.807,1.208,1.567,1.208h0.299v0.637c-1.017,0-2.292-0.082-3.348-0.082c-1.041,0-2.292,0.082-3.118,0.082V141.286z"
				/>
				<path
					fill="#231F20"
					d="M40.974,141.832l0.001-0.451h-0.204c-0.758,0-1.659-0.132-1.665-1.303v-11.106
		c0.005-1.172,0.906-1.303,1.665-1.303h0.204v-0.452c-0.978,0.001-2.207,0.085-3.235,0.085c-1.007,0-2.226-0.079-3.047-0.085v0.452
		h0.203c0.756,0,1.659,0.131,1.659,1.303v11.106c0,1.171-0.903,1.303-1.659,1.303h-0.203v0.451c0.821-0.007,2.018-0.085,3.024-0.085
		C38.749,141.747,39.974,141.827,40.974,141.832 M41.066,142.014c-1.026,0-2.295-0.085-3.35-0.085c-1.038,0-2.284,0.085-3.117,0.085
		h-0.092v-0.09v-0.636v-0.093H34.6h0.296c0.769-0.019,1.469-0.081,1.476-1.117v-11.106c-0.007-1.038-0.706-1.105-1.476-1.118h-0.389
		v-0.092v-0.729H34.6c0.832,0,2.103,0.083,3.14,0.083c1.054,0,2.324-0.083,3.326-0.083h0.094v0.095v0.726h-0.094h-0.295
		c-0.77,0.013-1.474,0.081-1.478,1.118v11.106c0.004,1.036,0.708,1.098,1.478,1.117h0.39v0.093v0.726H41.066z"
				/>
				<path
					fill="#231F20"
					d="M55.63,137.745l0.042-0.042v-7.947c0-1.74-1.21-1.994-1.845-1.994H53.36v-0.636
		c0.998,0,1.973,0.085,2.968,0.085c0.869,0,1.743-0.085,2.608-0.085v0.636h-0.315c-0.893,0-1.89,0.169-1.89,2.693v9.645
		c0,0.743,0.021,1.485,0.125,2.142H56.05l-10.916-12.171v8.737c0,1.845,0.358,2.479,1.991,2.479h0.361v0.637
		c-0.912,0-1.822-0.083-2.734-0.083c-0.952,0-1.928,0.083-2.883,0.083v-0.637h0.297c1.463,0,1.907-0.997,1.907-2.688v-8.932
		c0-1.186-0.978-1.905-1.928-1.905H41.87v-0.636c0.804,0,1.632,0.085,2.436,0.085c0.638,0,1.253-0.085,1.889-0.085L55.63,137.745z"
				/>
				<path
					fill="#231F20"
					d="M55.58,137.703v-0.008l-0.017-0.013L55.58,137.703z M55.63,137.745l0.067-0.061L55.63,137.745z
		 M56.051,142.146h0.701c-0.095-0.638-0.112-1.342-0.112-2.047v-9.645c0-2.544,1.067-2.785,1.98-2.787h0.223v-0.451
		c-0.835,0.006-1.672,0.083-2.515,0.083c-0.971,0-1.915-0.077-2.873-0.083l-0.002,0.451h0.375c0.652,0.002,1.936,0.292,1.936,2.088
		l-0.028,8.014l-0.042,0.041l-0.072,0.068l-9.428-10.662c-0.63,0-1.243,0.083-1.89,0.083c-0.777,0-1.573-0.077-2.342-0.083
		l-0.004,0.451h0.188c0.994,0.002,2.018,0.761,2.018,2.002v8.928c0,1.697-0.473,2.78-1.997,2.786l-0.205-0.006v0.455
		c0.918-0.007,1.864-0.085,2.79-0.085c0.884,0,1.767,0.078,2.642,0.085v-0.449h-0.268c-1.668-0.006-2.081-0.733-2.083-2.576v-8.974
		L56.051,142.146z M56.856,142.331l-0.873-0.03L45.224,130.31v8.498c0.026,1.843,0.306,2.367,1.902,2.387h0.454v0.092v0.727h-0.094
		c-0.917,0-1.83-0.085-2.734-0.085c-0.949,0-1.923,0.085-2.884,0.085h-0.093v-0.09v-0.729h0.093h0.299
		c1.401-0.008,1.801-0.908,1.817-2.597v-8.928c-0.004-1.129-0.93-1.816-1.837-1.816h-0.371v-0.096v-0.725h0.093
		c0.81,0,1.64,0.083,2.435,0.083c0.632,0,1.245-0.083,1.96-0.05l9.316,10.488v-7.797c-0.011-1.684-1.135-1.889-1.753-1.902h-0.561
		v-0.096v-0.725h0.094c1.002,0,1.977,0.083,2.968,0.083c0.862,0,1.731-0.083,2.608-0.083h0.093v0.092v0.729h-0.093H58.62
		c-0.876,0.023-1.773,0.1-1.799,2.6v9.645c0,0.742,0.024,1.482,0.125,2.126l0.019,0.106H56.856z"
				/>
				<path
					fill="#231F20"
					d="M62.112,128.185c-1.592,0-1.653,0.383-1.972,1.929h-0.636c0.083-0.593,0.189-1.187,0.255-1.801
		c0.085-0.596,0.127-1.188,0.127-1.801h0.509c0.17,0.636,0.701,0.613,1.275,0.613h10.934c0.575,0,1.104-0.021,1.148-0.657
		l0.506,0.087c-0.082,0.57-0.169,1.143-0.23,1.717c-0.041,0.572-0.041,1.143-0.041,1.715l-0.638,0.236
		c-0.043-0.784-0.148-2.038-1.568-2.038h-3.477v11.278c0,1.635,0.743,1.823,1.758,1.823h0.404v0.637
		c-0.827,0-2.312-0.082-3.455-0.082c-1.273,0-2.759,0.082-3.586,0.082v-0.637h0.404c1.168,0,1.759-0.104,1.759-1.779v-11.322H62.112
		z"
				/>
				<path
					fill="#231F20"
					d="M70.468,142.014c-0.835,0-2.318-0.084-3.456-0.084c-1.272,0-2.754,0.084-3.586,0.084h-0.09v-0.09v-0.729
		h0.09h0.404c1.168-0.027,1.638-0.042,1.665-1.687v-11.231h-3.383v-0.091v-0.095h3.567v11.417c0,1.702-0.686,1.874-1.849,1.876
		h-0.314v0.447c0.836-0.005,2.265-0.084,3.495-0.084c1.104,0,2.52,0.078,3.36,0.084v-0.447h-0.31
		c-1.025-0.002-1.851-0.254-1.851-1.92V128.09h3.569c1.422,0.005,1.61,1.214,1.655,2.003l0.458-0.169
		c0-0.554,0.002-1.108,0.041-1.665c0.062-0.548,0.139-1.086,0.219-1.63l-0.322-0.053c-0.099,0.617-0.696,0.65-1.228,0.642H61.67
		h-0.111c-0.498,0.001-1.042-0.024-1.233-0.615h-0.35c-0.004,0.586-0.044,1.155-0.124,1.72c-0.063,0.582-0.16,1.142-0.237,1.704
		h0.453c0.279-1.479,0.46-1.957,2.045-1.936v0.095v0.091c-1.57,0.031-1.536,0.293-1.882,1.86l-0.015,0.072h-0.075h-0.742l0.012-0.11
		c0.086-0.592,0.194-1.186,0.255-1.802c0.088-0.588,0.129-1.176,0.129-1.784v-0.094h0.091h0.582l0.016,0.067
		c0.143,0.534,0.535,0.538,1.076,0.548h0.111h10.933c0.59-0.009,1.021-0.017,1.057-0.572l0.008-0.1l0.096,0.02l0.599,0.095
		l-0.015,0.093c-0.084,0.569-0.167,1.14-0.23,1.708c-0.04,0.567-0.04,1.138-0.04,1.711v0.064l-0.062,0.024l-0.749,0.275
		l-0.006-0.123c-0.058-0.798-0.14-1.951-1.48-1.951h-3.385v11.187c0.022,1.599,0.656,1.711,1.666,1.731h0.496v0.092v0.727H70.468z"
				/>
				<path
					fill="#231F20"
					d="M74.935,141.286h0.299c0.761,0,1.569-0.104,1.569-1.208v-11.106c0-1.105-0.808-1.21-1.569-1.21h-0.299
		v-0.637c1.29,0,3.499,0.085,5.276,0.085c1.784,0,3.986-0.085,5.428-0.085c-0.037,0.911-0.017,2.314,0.045,3.245l-0.639,0.168
		c-0.102-1.378-0.356-2.478-2.583-2.478h-2.943v5.551h2.518c1.272,0,1.549-0.718,1.675-1.864h0.636
		c-0.042,0.828-0.064,1.655-0.064,2.481c0,0.807,0.022,1.612,0.064,2.416l-0.636,0.127c-0.125-1.27-0.189-2.097-1.653-2.097h-2.54
		v4.937c0,1.38,1.225,1.38,2.582,1.38c2.544,0,3.667-0.171,4.304-2.584l0.591,0.146c-0.276,1.126-0.529,2.246-0.718,3.371
		c-1.358,0-3.796-0.082-5.701-0.082c-1.912,0-4.433,0.082-5.643,0.082V141.286z"
				/>
				<path
					fill="#231F20"
					d="M86.198,141.831c0.185-1.072,0.427-2.142,0.687-3.21l-0.417-0.105c-0.635,2.371-1.865,2.583-4.367,2.567
		c-1.336,0-2.671,0-2.679-1.473v-5.029h2.636c1.481-0.015,1.63,0.877,1.736,2.083l0.458-0.093c-0.041-0.782-0.062-1.566-0.062-2.343
		c0-0.796,0.021-1.591,0.062-2.391h-0.458c-0.119,1.107-0.466,1.88-1.757,1.867h-2.614v-5.739h3.04
		c2.205-0.017,2.57,1.124,2.666,2.458l0.456-0.125c-0.037-0.598-0.061-1.367-0.061-2.074c0-0.363,0.009-0.707,0.022-1.007
		c-1.44,0.006-3.59,0.083-5.333,0.083c-1.742,0-3.886-0.077-5.184-0.083v0.451h0.205c0.754,0.002,1.656,0.132,1.661,1.305v11.106
		c-0.005,1.171-0.907,1.299-1.661,1.306h-0.205v0.447c1.234-0.004,3.685-0.084,5.547-0.084
		C82.447,141.747,84.832,141.827,86.198,141.831 M86.277,142.014c-1.36,0-3.8-0.088-5.701-0.088c-1.91,0-4.43,0.088-5.641,0.088
		h-0.089v-0.09v-0.637v-0.092h0.089h0.299c0.767-0.013,1.465-0.081,1.475-1.117v-11.106c-0.009-1.036-0.708-1.105-1.475-1.118
		h-0.387v-0.092v-0.729h0.089c1.295,0,3.501,0.083,5.277,0.083c1.782,0,3.983-0.083,5.427-0.083h0.094l-0.003,0.098
		c-0.014,0.317-0.022,0.694-0.022,1.093c0,0.733,0.022,1.536,0.064,2.139l0.004,0.075l-0.072,0.022l-0.745,0.195l-0.003-0.11
		c-0.125-1.375-0.31-2.376-2.493-2.396h-2.857l-0.002,5.369h2.433c1.222-0.013,1.44-0.637,1.585-1.78l0.005-0.085h0.084h0.731
		l-0.002,0.096c-0.041,0.828-0.066,1.653-0.066,2.479c0,0.802,0.025,1.607,0.066,2.412l0.002,0.077l-0.077,0.017l-0.738,0.147
		l-0.005-0.1c-0.147-1.295-0.156-2.004-1.563-2.019h-2.453v4.848c0.003,1.288,1.114,1.281,2.495,1.288
		c2.553-0.015,3.575-0.14,4.214-2.518l0.022-0.086l0.089,0.015l0.679,0.176l-0.019,0.087c-0.275,1.122-0.528,2.244-0.72,3.365
		l-0.016,0.075H86.277z"
				/>
				<path
					fill="#231F20"
					d="M92.573,134.288h1.036c2.123,0,3.265-0.803,3.265-3.306c0-1.885-1.208-3.093-3.097-3.093
		c-0.636,0-0.907,0.065-1.204,0.085V134.288z M89.86,129.37c0-1.545-0.849-1.609-1.507-1.609H87.97v-0.636
		c0.679,0,1.993,0.085,3.287,0.085c1.269,0,2.289-0.085,3.412-0.085c2.668,0,5.047,0.72,5.047,3.733
		c0,1.907-1.273,3.071-2.947,3.732l3.623,5.424c0.595,0.896,1.016,1.148,2.057,1.273v0.637c-0.701,0-1.38-0.082-2.077-0.082
		c-0.657,0-1.339,0.082-1.993,0.082c-1.633-2.14-3.034-4.429-4.411-6.871h-1.397v4.54c0,1.632,0.762,1.694,1.733,1.694h0.384v0.637
		c-1.211,0-2.436-0.082-3.647-0.082c-1.017,0-2.014,0.082-3.074,0.082v-0.637h0.383c0.787,0,1.507-0.359,1.507-1.143V129.37z"
				/>
				<path
					fill="#231F20"
					d="M93.609,134.199c2.098-0.021,3.156-0.749,3.177-3.211c-0.013-1.853-1.163-3.001-3.009-3.009
		c-0.572,0-0.842,0.052-1.113,0.079v6.141H93.609z M92.572,134.379h-0.094v-6.491l0.081-0.006c0.29-0.024,0.576-0.082,1.217-0.082
		c1.931,0,3.188,1.255,3.19,3.188c-0.006,2.53-1.219,3.391-3.358,3.392H92.572z M92.572,134.961h1.449l0.026,0.048
		c1.38,2.436,2.773,4.725,4.334,6.824c0.645,0,1.327-0.085,1.987-0.085c0.677,0,1.331,0.074,1.989,0.084v-0.465
		c-0.993-0.121-1.46-0.422-2.039-1.3l-3.691-5.518l0.105-0.042c1.66-0.654,2.891-1.787,2.891-3.65
		c-0.001-2.941-2.289-3.624-4.954-3.638c-1.116,0-2.135,0.085-3.412,0.085c-1.245,0-2.503-0.079-3.197-0.085v0.451h0.292
		c0.658,0.002,1.594,0.111,1.594,1.703v10.774c0,0.851-0.797,1.237-1.594,1.24h-0.292v0.447c1.019-0.004,1.987-0.084,2.983-0.084
		c1.184,0,2.381,0.08,3.553,0.084v-0.447h-0.29c-0.965-0.002-1.828-0.121-1.828-1.795v-4.627H92.572z M102.45,142.014
		c-0.711,0-1.385-0.085-2.083-0.085c-0.646,0-1.324,0.085-2.062,0.049c-1.626-2.135-3.021-4.41-4.39-6.83h-1.253v4.44
		c0.024,1.596,0.663,1.584,1.643,1.606h0.476v0.092v0.727h-0.094c-1.212,0-2.443-0.085-3.645-0.085
		c-1.012,0-2.009,0.085-3.073,0.085h-0.092v-0.09v-0.729h0.092h0.383c0.762-0.005,1.407-0.338,1.41-1.051V129.37
		c-0.016-1.503-0.752-1.495-1.41-1.516h-0.475v-0.092v-0.73h0.092c0.686,0,1.995,0.083,3.287,0.083c1.266,0,2.282-0.083,3.412-0.083
		c2.673,0.006,5.132,0.742,5.139,3.822c0,1.913-1.265,3.109-2.899,3.776l3.56,5.333c0.593,0.879,0.962,1.099,1.994,1.232
		l0.077,0.012v0.08v0.727H102.45z"
				/>
				<path
					fill="#231F20"
					d="M116.843,137.745l0.037-0.042v-7.947c0-1.74-1.204-1.994-1.841-1.994h-0.465v-0.636
		c0.997,0,1.968,0.085,2.968,0.085c0.871,0,1.734-0.085,2.609-0.085v0.636h-0.319c-0.891,0-1.887,0.169-1.887,2.693v9.645
		c0,0.743,0.021,1.485,0.125,2.142h-0.802l-10.917-12.171v8.737c0,1.845,0.358,2.479,1.99,2.479h0.361v0.637
		c-0.911,0-1.824-0.083-2.735-0.083c-0.958,0-1.931,0.083-2.884,0.083v-0.637h0.295c1.464,0,1.911-0.997,1.911-2.688v-8.932
		c0-1.186-0.976-1.905-1.93-1.905h-0.276v-0.636c0.802,0,1.635,0.085,2.439,0.085c0.63,0,1.248-0.085,1.885-0.085L116.843,137.745z"
				/>
				<path
					fill="#231F20"
					d="M116.79,137.703v-0.006l-0.015-0.016L116.79,137.703z M116.84,137.745l0.069-0.061L116.84,137.745z
		 M117.268,142.146h0.694c-0.093-0.634-0.112-1.342-0.112-2.047v-9.645c0.002-2.544,1.074-2.78,1.981-2.787h0.223v-0.451
		c-0.835,0.006-1.672,0.083-2.513,0.083c-0.974,0-1.919-0.077-2.878-0.083v0.451h0.375c0.653,0.006,1.937,0.292,1.937,2.088
		l-0.031,8.014l-0.038,0.041l-0.067,0.07l-9.432-10.664c-0.631,0-1.246,0.083-1.886,0.083c-0.786,0-1.578-0.077-2.349-0.083v0.451
		h0.186c0.997,0.006,2.017,0.758,2.017,1.999v8.927c0,1.701-0.479,2.784-1.999,2.791l-0.205-0.002v0.451
		c0.916-0.006,1.86-0.085,2.79-0.085c0.889,0,1.77,0.078,2.647,0.085v-0.448h-0.269c-1.668-0.002-2.084-0.73-2.089-2.577v-8.97
		L117.268,142.146z M118.07,142.331l-0.871-0.03l-10.76-11.99v8.495c0.025,1.847,0.304,2.368,1.903,2.389h0.449v0.092v0.727h-0.092
		c-0.916,0-1.826-0.088-2.735-0.088c-0.946,0-1.926,0.088-2.881,0.088h-0.095v-0.09v-0.729h0.095h0.295
		c1.4-0.005,1.801-0.908,1.815-2.602v-8.927c-0.002-1.13-0.927-1.813-1.833-1.813h-0.372v-0.092v-0.729h0.095
		c0.81,0,1.639,0.083,2.439,0.083c0.623,0,1.237-0.083,1.948-0.056l9.319,10.493v-7.797c-0.005-1.684-1.135-1.892-1.751-1.902
		h-0.559v-0.092v-0.729h0.092c1.001,0,1.979,0.083,2.97,0.083c0.864,0,1.731-0.083,2.606-0.083h0.094v0.095v0.726h-0.094h-0.315
		c-0.875,0.021-1.776,0.1-1.797,2.6v9.645c0,0.742,0.019,1.477,0.127,2.128l0.011,0.104H118.07z"
				/>
				<path
					fill="#231F20"
					d="M126.654,129.5h-0.044l-1.97,6h3.961L126.654,129.5z M123.559,138.892
		c-0.214,0.719-0.469,1.275-0.469,1.651c0,0.639,0.893,0.744,1.59,0.744h0.237v0.636c-0.851-0.046-1.717-0.082-2.57-0.082
		c-0.763,0-1.522,0.036-2.287,0.082v-0.636h0.129c0.825,0,1.527-0.489,1.842-1.38l3.392-9.727c0.277-0.786,0.659-1.845,0.788-2.631
		c0.674-0.232,1.526-0.654,1.927-0.911c0.066-0.021,0.105-0.043,0.169-0.043c0.064,0,0.103,0,0.15,0.067
		c0.063,0.168,0.125,0.359,0.19,0.528l3.903,11.089c0.254,0.74,0.506,1.523,0.777,2.163c0.259,0.595,0.704,0.846,1.406,0.846h0.127
		v0.636c-0.955-0.046-1.911-0.082-2.925-0.082c-1.039,0-2.103,0.036-3.183,0.082v-0.636h0.234c0.484,0,1.316-0.085,1.316-0.615
		c0-0.273-0.191-0.846-0.428-1.527l-0.826-2.458h-4.812L123.559,138.892z"
				/>
				<path
					fill="#231F20"
					d="M126.562,129.528l0.049-0.016L126.562,129.528z M124.764,135.407h3.712l-1.845-5.681L124.764,135.407z
		 M124.511,135.591l2.029-6.185h0.071h0.043v0.094l-0.022,0.006l0.022-0.006v-0.094h0.064l2.014,6.185H124.511z M128.845,141.825
		c1.048-0.037,2.078-0.078,3.091-0.078c0.983,0,1.907,0.042,2.829,0.078v-0.444h-0.031c-0.727,0.005-1.227-0.281-1.487-0.906
		c-0.276-0.64-0.534-1.427-0.784-2.17l-3.903-11.088c-0.064-0.169-0.125-0.359-0.18-0.509c-0.021-0.021-0.016-0.021-0.033-0.021
		h-0.04c-0.043,0-0.068,0.013-0.123,0.027c-0.407,0.265-1.258,0.683-1.888,0.848c-0.129,0.803-0.512,1.863-0.787,2.648l-3.391,9.728
		c-0.323,0.922-1.068,1.446-1.929,1.444h-0.035v0.444c0.728-0.037,1.461-0.078,2.197-0.078c0.82,0,1.656,0.042,2.467,0.078v-0.444
		h-0.136c-0.692-0.009-1.657-0.085-1.681-0.836c0.002-0.42,0.262-0.962,0.469-1.679l0.091,0.027l-0.091-0.029l0.698-2.266h4.944
		l0.849,2.518c0.238,0.682,0.431,1.247,0.431,1.556c-0.031,0.65-0.924,0.697-1.404,0.709h-0.141V141.825z M134.853,142.014
		c-0.952-0.041-1.908-0.088-2.917-0.088c-1.039,0-2.096,0.047-3.178,0.088l-0.098,0.005v-0.096v-0.733h0.093h0.234
		c0.491,0,1.219-0.11,1.221-0.519c0.005-0.241-0.185-0.822-0.418-1.497l-0.807-2.398h-4.676l-0.659,2.142
		c-0.214,0.72-0.471,1.28-0.467,1.625c0.007,0.518,0.799,0.646,1.502,0.646h0.326v0.096v0.732l-0.096-0.005
		c-0.848-0.041-1.713-0.088-2.561-0.088c-0.757,0-1.524,0.047-2.283,0.088l-0.099,0.005v-0.096v-0.733h0.091h0.129
		c0.788-0.002,1.447-0.452,1.753-1.313l3.395-9.731c0.274-0.784,0.659-1.839,0.842-2.686c0.665-0.226,1.518-0.653,1.926-0.909
		c0.059-0.021,0.118-0.049,0.203-0.049c0.052-0.003,0.166,0.011,0.235,0.121c0.06,0.174,0.127,0.364,0.191,0.535l3.903,11.088
		c0.25,0.742,0.503,1.525,0.781,2.153c0.246,0.565,0.635,0.788,1.316,0.79h0.214v0.096v0.732L134.853,142.014z"
				/>
				<path
					fill="#231F20"
					d="M135.792,128.185c-1.59,0-1.654,0.383-1.973,1.929h-0.638c0.084-0.593,0.192-1.187,0.258-1.801
		c0.083-0.596,0.124-1.188,0.124-1.801h0.513c0.166,0.636,0.697,0.613,1.269,0.613h10.94c0.57,0,1.099-0.021,1.142-0.657
		l0.507,0.087c-0.079,0.57-0.163,1.143-0.23,1.717c-0.047,0.572-0.047,1.143-0.047,1.715l-0.633,0.236
		c-0.038-0.784-0.144-2.038-1.567-2.038h-3.476v11.278c0,1.635,0.743,1.823,1.758,1.823h0.405v0.637
		c-0.827,0-2.309-0.082-3.457-0.082c-1.269,0-2.758,0.082-3.584,0.082v-0.637h0.404c1.168,0,1.759-0.104,1.759-1.779v-11.322
		H135.792z"
				/>
				<path
					fill="#231F20"
					d="M144.144,142.014c-0.833,0-2.319-0.084-3.458-0.084c-1.266,0-2.751,0.084-3.581,0.084h-0.094v-0.09v-0.729
		h0.094h0.403c1.169-0.027,1.638-0.042,1.666-1.687l-0.002-11.231h-3.38v-0.091v-0.095h3.566v11.417c0,1.702-0.686,1.87-1.851,1.874
		h-0.313v0.451c0.838-0.007,2.262-0.085,3.491-0.085c1.108,0,2.526,0.078,3.364,0.085v-0.451h-0.312
		c-1.021-0.004-1.847-0.249-1.849-1.918V128.09h3.567c1.424,0.005,1.61,1.214,1.65,2.003l0.461-0.169
		c0-0.554,0.003-1.108,0.046-1.663c0.057-0.546,0.137-1.089,0.215-1.63l-0.32-0.056c-0.097,0.617-0.696,0.651-1.223,0.642h-10.94
		h-0.108c-0.5,0.005-1.041-0.024-1.233-0.617h-0.346c-0.005,0.587-0.047,1.157-0.13,1.722c-0.058,0.585-0.16,1.146-0.241,1.704
		h0.455c0.279-1.479,0.462-1.959,2.051-1.936v0.095v0.091c-1.572,0.027-1.537,0.293-1.884,1.86l-0.015,0.072h-0.074h-0.744
		l0.013-0.105c0.089-0.596,0.193-1.191,0.255-1.802c0.087-0.592,0.126-1.181,0.126-1.788v-0.094h0.094h0.579l0.018,0.067
		c0.148,0.534,0.535,0.538,1.077,0.548h0.108h10.94c0.587-0.009,1.015-0.017,1.052-0.57l0.003-0.102l0.099,0.02l0.602,0.095
		l-0.015,0.093c-0.087,0.569-0.168,1.14-0.231,1.708c-0.044,0.567-0.044,1.139-0.044,1.711v0.064l-0.062,0.024l-0.75,0.275
		l-0.003-0.123c-0.056-0.798-0.139-1.951-1.479-1.951h-3.385v11.187c0.022,1.599,0.657,1.711,1.667,1.731h0.494v0.092v0.727H144.144
		z"
				/>
				<path
					fill="#231F20"
					d="M148.718,141.286h0.297c0.764,0,1.567-0.104,1.567-1.208v-11.106c0-1.105-0.802-1.21-1.567-1.21h-0.297
		v-0.637c0.828,0,2.097,0.085,3.135,0.085c1.063,0,2.335-0.085,3.334-0.085v0.637h-0.298c-0.766,0-1.572,0.105-1.572,1.21v11.106
		c0,1.104,0.806,1.208,1.572,1.208h0.298v0.637c-1.019,0-2.292-0.082-3.351-0.082c-1.041,0-2.29,0.082-3.117,0.082V141.286z"
				/>
				<path
					fill="#231F20"
					d="M155.09,141.831v-0.45h-0.201c-0.761,0-1.661-0.132-1.661-1.303v-11.106c0-1.172,0.9-1.303,1.661-1.305
		h0.201v-0.451c-0.978,0.006-2.205,0.083-3.237,0.083c-1.006,0-2.22-0.077-3.042-0.083v0.451h0.205
		c0.753,0.002,1.657,0.132,1.659,1.305v11.106c-0.002,1.171-0.906,1.303-1.659,1.303h-0.205v0.45
		c0.816-0.009,2.016-0.084,3.025-0.084C152.863,141.747,154.09,141.825,155.09,141.831 M155.186,142.014
		c-1.025,0-2.293-0.088-3.351-0.088c-1.038,0-2.289,0.088-3.117,0.088h-0.091v-0.09v-0.637v-0.092h0.091h0.298
		c0.764-0.013,1.469-0.08,1.473-1.117v-11.106c-0.005-1.036-0.709-1.105-1.473-1.118h-0.389v-0.092v-0.729h0.091
		c0.828,0,2.103,0.083,3.135,0.083c1.057,0,2.329-0.083,3.334-0.083h0.088v0.092v0.729h-0.088h-0.297
		c-0.777,0.013-1.473,0.082-1.481,1.118v11.106c0.008,1.037,0.704,1.104,1.481,1.117h0.385v0.092v0.727H155.186z"
				/>
				<path
					fill="#231F20"
					d="M163.959,141.308c4.114,0,4.831-3.627,4.831-6.719c0-3.098-1.671-6.849-5.192-6.849
		c-3.709,0-4.812,3.308-4.812,6.146C158.786,137.681,160.526,141.308,163.959,141.308 M163.638,126.808
		c4.52,0,8.122,2.801,8.122,7.316c0,4.877-3.498,8.118-8.012,8.118c-4.497,0-7.929-3.053-7.929-7.611
		C155.819,130.223,159.231,126.808,163.638,126.808"
				/>
				<path
					fill="#231F20"
					d="M158.693,133.886c0.007-2.852,1.12-6.24,4.905-6.24c3.6,0.008,5.279,3.828,5.286,6.943
		c-0.007,3.091-0.734,6.806-4.924,6.806v-0.087v-0.092c4.031-0.004,4.731-3.535,4.738-6.626c0-3.071-1.654-6.751-5.1-6.757
		c-3.637,0.004-4.711,3.23-4.721,6.054c0.002,3.776,1.726,7.323,5.083,7.329v0.092v0.087
		C160.441,141.392,158.7,137.703,158.693,133.886 M155.724,134.63c0.009-4.459,3.46-7.908,7.913-7.915v0.092v0.093
		c-4.358,0-7.729,3.369-7.734,7.73c0.009,4.507,3.392,7.514,7.845,7.516c4.468-0.002,7.916-3.196,7.922-8.025
		c-0.004-4.459-3.55-7.217-8.033-7.22v-0.093v-0.092c4.552,0.005,8.206,2.834,8.213,7.405c-0.005,4.928-3.545,8.202-8.102,8.21
		C159.214,142.323,155.733,139.239,155.724,134.63"
				/>
				<path
					fill="#231F20"
					d="M186.046,137.745l0.044-0.042v-7.947c0-1.74-1.212-1.994-1.848-1.994h-0.462v-0.636
		c0.994,0,1.971,0.085,2.964,0.085c0.872,0,1.741-0.085,2.611-0.085v0.636h-0.319c-0.889,0-1.889,0.169-1.889,2.693v9.645
		c0,0.743,0.022,1.485,0.129,2.142h-0.806l-10.919-12.171v8.737c0,1.845,0.361,2.479,1.99,2.479h0.364v0.637
		c-0.912,0-1.822-0.083-2.734-0.083c-0.954,0-1.93,0.083-2.885,0.083v-0.637h0.298c1.465,0,1.907-0.997,1.907-2.688v-8.932
		c0-1.186-0.972-1.905-1.931-1.905h-0.274v-0.636c0.806,0,1.632,0.085,2.439,0.085c0.635,0,1.246-0.085,1.885-0.085L186.046,137.745
		z"
				/>
				<path
					fill="#231F20"
					d="M185.996,137.703v-0.006l-0.016-0.016L185.996,137.703z M186.046,137.745l0.067-0.061L186.046,137.745z
		 M186.471,142.146h0.695c-0.09-0.638-0.11-1.342-0.11-2.047v-9.645c0-2.549,1.07-2.78,1.98-2.787h0.23v-0.451
		c-0.842,0.006-1.675,0.083-2.523,0.083c-0.965,0-1.913-0.077-2.873-0.083v0.451h0.373c0.654,0.006,1.934,0.295,1.934,2.088
		l-0.022,8.014l-0.041,0.041l-0.067,0.07l-9.435-10.664c-0.627,0-1.244,0.083-1.886,0.083c-0.781,0-1.577-0.077-2.349-0.083v0.451
		h0.186c0.997,0.006,2.021,0.758,2.021,1.999v8.931c0,1.697-0.473,2.78-1.999,2.786l-0.208-0.002v0.451
		c0.92-0.006,1.864-0.085,2.795-0.085c0.885,0,1.763,0.078,2.642,0.085v-0.448h-0.273c-1.664-0.002-2.081-0.73-2.081-2.576v-8.974
		L186.471,142.146z M187.278,142.331l-0.877-0.03l-10.759-11.99v8.496c0.025,1.845,0.306,2.364,1.897,2.383h0.457v0.096v0.726h-0.09
		c-0.918,0-1.828-0.085-2.735-0.085c-0.95,0-1.925,0.085-2.887,0.085h-0.087v-0.09v-0.733h0.087h0.299
		c1.397-0.004,1.8-0.904,1.816-2.593v-8.931c-0.001-1.13-0.927-1.813-1.838-1.813h-0.364v-0.092v-0.729h0.087
		c0.813,0,1.639,0.083,2.44,0.083c0.629,0,1.238-0.083,1.957-0.05l9.315,10.488v-7.797c-0.007-1.684-1.136-1.889-1.755-1.902h-0.559
		v-0.092v-0.729h0.097c0.996,0,1.974,0.083,2.961,0.083c0.867,0,1.733-0.083,2.614-0.083h0.089v0.092v0.729h-0.089h-0.32
		c-0.874,0.023-1.776,0.103-1.794,2.6v9.645c0,0.742,0.017,1.482,0.12,2.128l0.018,0.104H187.278z"
				/>
				<path
					fill="#231F20"
					d="M195.86,129.5h-0.042l-1.976,6h3.97L195.86,129.5z M192.76,138.892c-0.208,0.719-0.464,1.275-0.464,1.651
		c0,0.639,0.893,0.744,1.588,0.744h0.237v0.636c-0.849-0.046-1.719-0.082-2.568-0.082c-0.763,0-1.525,0.036-2.285,0.082v-0.636
		h0.121c0.831,0,1.533-0.489,1.843-1.38l3.399-9.727c0.274-0.786,0.658-1.845,0.78-2.631c0.681-0.232,1.527-0.654,1.936-0.911
		c0.059-0.021,0.102-0.043,0.168-0.043c0.061,0,0.102,0,0.145,0.067c0.064,0.168,0.128,0.359,0.192,0.528l3.9,11.089
		c0.253,0.74,0.509,1.523,0.786,2.163c0.254,0.595,0.699,0.846,1.398,0.846h0.13v0.636c-0.955-0.046-1.911-0.082-2.928-0.082
		c-1.037,0-2.099,0.036-3.181,0.082v-0.636h0.235c0.484,0,1.316-0.085,1.316-0.615c0-0.273-0.19-0.846-0.427-1.527l-0.826-2.458
		h-4.812L192.76,138.892z"
				/>
				<path
					fill="#231F20"
					d="M195.772,129.528l0.042-0.016L195.772,129.528z M193.971,135.407h3.708l-1.844-5.678L193.971,135.407z
		 M193.715,135.591l2.036-6.184h0.063h0.046v0.094l-0.024,0.006l0.024-0.006v-0.094h0.064l2.005,6.184H193.715z M198.046,141.827
		c1.049-0.038,2.081-0.08,3.091-0.08c0.985,0,1.907,0.042,2.833,0.078l-0.002-0.444h-0.036c-0.718,0.002-1.218-0.281-1.483-0.906
		c-0.279-0.64-0.531-1.427-0.785-2.167l-3.901-11.091c-0.063-0.169-0.13-0.359-0.18-0.505c-0.018-0.025-0.016-0.025-0.029-0.025
		h-0.042c-0.046,0-0.07,0.014-0.12,0.029c-0.415,0.259-1.263,0.684-1.889,0.846c-0.132,0.803-0.516,1.861-0.789,2.648l-3.395,9.728
		c-0.322,0.922-1.063,1.446-1.93,1.444h-0.031v0.444c0.73-0.037,1.458-0.078,2.196-0.078c0.821,0,1.66,0.042,2.474,0.078v-0.444
		h-0.143c-0.69-0.009-1.656-0.082-1.682-0.838c0.005-0.418,0.266-0.959,0.474-1.678l0.085,0.027l-0.085-0.029l0.697-2.266h4.941
		l0.852,2.518c0.234,0.682,0.427,1.247,0.427,1.556c-0.03,0.65-0.922,0.697-1.403,0.709h-0.143V141.827z M204.056,142.014
		c-0.955-0.038-1.907-0.085-2.918-0.085c-1.034,0-2.097,0.047-3.177,0.085l-0.094,0.005v-0.096v-0.729h0.091h0.232
		c0.492,0,1.223-0.114,1.223-0.523c0.006-0.241-0.186-0.82-0.424-1.497l-0.804-2.398h-4.68l-0.655,2.142
		c-0.213,0.726-0.464,1.28-0.462,1.624c0,0.52,0.795,0.651,1.496,0.651h0.324v0.092v0.733l-0.096-0.005
		c-0.846-0.038-1.715-0.085-2.559-0.085c-0.759,0-1.52,0.047-2.285,0.085l-0.092,0.005v-0.096v-0.729h0.092h0.121
		c0.79-0.004,1.451-0.457,1.762-1.316l3.391-9.731c0.272-0.784,0.654-1.839,0.841-2.683c0.666-0.231,1.517-0.656,1.929-0.912
		c0.055-0.021,0.114-0.046,0.201-0.046c0.054-0.006,0.165,0.009,0.23,0.124c0.064,0.167,0.127,0.36,0.196,0.531l3.899,11.088
		c0.255,0.742,0.508,1.525,0.783,2.157c0.25,0.561,0.633,0.784,1.311,0.79h0.219v0.092v0.733L204.056,142.014z"
				/>
				<path
					fill="#231F20"
					d="M209.405,139.844c0,0.853,0.589,1.103,1.269,1.192c0.868,0.063,1.823,0.063,2.801-0.045
		c0.889-0.107,1.652-0.613,2.033-1.147c0.337-0.465,0.528-1.059,0.658-1.524h0.614c-0.234,1.208-0.53,2.397-0.784,3.604
		c-1.861,0-3.733-0.082-5.595-0.082c-1.867,0-3.732,0.082-5.596,0.082v-0.637h0.293c0.765,0,1.595-0.104,1.595-1.419v-10.895
		c0-1.105-0.83-1.211-1.595-1.211h-0.293v-0.636c1.121,0,2.226,0.085,3.348,0.085c1.083,0,2.141-0.085,3.225-0.085v0.636h-0.533
		c-0.806,0-1.438,0.023-1.438,1.146V139.844z"
				/>
				<path
					fill="#231F20"
					d="M215.918,141.831c0.245-1.152,0.523-2.277,0.751-3.421h-0.437c-0.13,0.461-0.319,1.03-0.651,1.491
		c-0.397,0.549-1.181,1.067-2.101,1.182c-0.555,0.056-1.106,0.085-1.625,0.085c-0.411,0-0.807-0.018-1.193-0.045
		c-0.69-0.076-1.356-0.371-1.356-1.279v-10.937c0-1.179,0.746-1.24,1.537-1.24h0.436v-0.451c-1.044,0.006-2.075,0.085-3.13,0.085
		c-1.096,0-2.17-0.079-3.255-0.085v0.451h0.202c0.756,0,1.682,0.132,1.682,1.301v10.899c0,1.372-0.922,1.514-1.682,1.514h-0.202
		v0.45c1.831-0.004,3.664-0.084,5.505-0.084C212.242,141.747,214.082,141.827,215.918,141.831 M215.995,142.014
		c-1.87,0-3.736-0.085-5.596-0.085c-1.865,0-3.731,0.085-5.601,0.085h-0.089v-0.09v-0.729h0.089h0.298
		c0.766-0.019,1.494-0.072,1.503-1.327v-10.899c-0.009-1.032-0.734-1.101-1.503-1.114h-0.386v-0.092v-0.729h0.089
		c1.129,0,2.233,0.083,3.351,0.083c1.079,0,2.135-0.083,3.226-0.083h0.085v0.092v0.729h-0.085h-0.533
		c-0.822,0.021-1.333-0.016-1.351,1.053v10.937c0.005,0.793,0.524,1.005,1.187,1.099c0.373,0.026,0.768,0.04,1.175,0.04
		c0.519,0,1.057-0.024,1.605-0.082c0.864-0.103,1.607-0.602,1.973-1.107c0.328-0.454,0.513-1.034,0.641-1.496l0.017-0.07h0.072
		h0.727l-0.019,0.111c-0.24,1.212-0.531,2.395-0.788,3.603l-0.017,0.071H215.995z"
				/>
				<path
					fill="#231F20"
					d="M216.163,128.761h0.263c0.288,0,0.422-0.217,0.422-0.57c0-0.355-0.205-0.48-0.436-0.48h-0.249V128.761z
		 M215.411,129.938v-0.108c0.273-0.039,0.324-0.032,0.324-0.199v-1.654c0-0.233-0.023-0.314-0.315-0.3v-0.114h1.143
		c0.393,0,0.755,0.188,0.755,0.594c0,0.331-0.219,0.578-0.528,0.673l0.368,0.512c0.171,0.231,0.366,0.45,0.491,0.527v0.071h-0.434
		c-0.209,0-0.393-0.438-0.802-1.026h-0.248v0.74c0,0.146,0.052,0.139,0.326,0.178v0.108H215.411z M216.52,130.572
		c1.001,0,1.766-0.851,1.766-1.811c0-0.961-0.756-1.819-1.766-1.819c-1.005,0-1.769,0.857-1.769,1.819
		C214.751,129.721,215.515,130.572,216.52,130.572 M216.52,126.524c1.279,0,2.233,0.982,2.233,2.237
		c0,1.255-0.955,2.226-2.233,2.226c-1.276,0-2.232-0.972-2.232-2.226C214.288,127.506,215.244,126.524,216.52,126.524"
				/>
			</g>
			<g>
				<circle fill="#FFFFFF" cx="120.014" cy="52.283" r="35.904" />
				<path
					fill="#004A97"
					d="M120.064,88.828c-20.576,0.098-37.511-16.572-37.511-36.863c0-22.176,16.935-37.515,37.511-37.511h9.642
		c20.332-0.004,38.889,15.328,38.889,37.511c0,20.285-18.557,36.863-38.889,36.863H120.064z M120.147,17.529
		c-18.803,0.007-34.037,15.244-34.04,34.047c0.003,18.801,15.237,34.035,34.04,34.039c18.803-0.004,34.04-15.238,34.045-34.039
		C154.188,32.773,138.95,17.536,120.147,17.529z M112.419,71.708v-40.27c-8.091,3.116-13.83,10.946-13.851,20.137
		C98.589,60.765,104.328,68.596,112.419,71.708z M141.728,51.576c-0.014-9.194-5.761-17.036-13.86-20.141v40.282
		C135.966,68.606,141.714,60.772,141.728,51.576z"
				/>
			</g>
		</svg>
	);
};
